<template> 
  <TsSection append-class="mb-0">
    <TsRow append-class="gap-2 max-md:mb-4 items-start max-lg:flex-wrap" no-gutter>
      <TsColumn>
        <div class="pt-4 md:pt-10 md:px-10 mb-4 md:mb-10">
          <TsAuthentication view="signup"/>
        </div>
      </TsColumn>
      <TsColumn append-class="xl:min-w-max max-lg:is-12 lg:sticky lg:top-[125px]">
        <div class="relative max-w-max mx-auto">
          <TsImage
              v-if="isDesktop"
              src="/images/sign-up-banner-store.webp"
              class="block max-lg:hidden"
              width="632"
              height="656"
              data-testid="signup-banner-image"
              alt="signup-banner-image"
              
          />
        </div>
      </TsColumn>
    </TsRow>
  </TsSection>
</template>
<script setup>

const TsAuthentication = defineAsyncComponent(
    () => import('~/components/auth/TsAuthentication.vue')
);

const {isDesktop} = useDevice();


if (useAuthStore().is_authenticated) {
  navigateTo({path: "/"});
}

useSeoMeta({
  title: "Toolstation | Sign Up",
});

definePageMeta({
  layout: "auth",
});

</script>
